import installConfig from './config';
import { SouthcnPlugins } from 'southcn-mobile-ui';
import { pcModalMap } from './modalDefined';

const {installNotify, installHttp, installBus, installStorage, installAlias, installStyle, installFilters, installModal, installUtil} = SouthcnPlugins;
const injection = {};

export default Object.assign(injection, {

    install (Vue) {
        installHttp(injection, Vue);
        installBus(injection, Vue);
        installConfig(injection, Vue);
        installStyle(injection, Vue);
        installFilters(injection, Vue);
        installModal(injection, Vue, pcModalMap);
        installNotify(injection, Vue);
        installStorage(injection, Vue);
        installAlias(injection, Vue);
        installUtil(injection, Vue, {
            getElementTop (el) {
                let actualTop = el.offsetTop;
                let current = el.offsetParent;
                while (current !== null) {
                    actualTop += current.offsetTop;
                    current = current.offsetParent;
                }
                return actualTop;
            },
            setIframeHeight: function () {
                setTimeout(() => {
                    if (window.parent) {
                        const height = document.querySelector('#app').offsetHeight;
                        try {
                            let $iframes = window.parent.document.getElementsByTagName('iframe');
                            for (let i = 0; i < $iframes.length; i++) {
                                $iframes[i] && ($iframes[i].style.height = height + 'px');
                            }
                        } catch (e) {
                            window.postMessage({
                                height: height,
                                id: window._CONFIG.QID,
                                qid: window._CONFIG.QID,
                                type: 'yjzj'
                            }, '*');
                            window.parent.postMessage({
                                height: height,
                                id: window._CONFIG.QID,
                                qid: window._CONFIG.QID,
                                type: 'yjzj'
                            }, '*');
                        }
                    }
                });
            },
            url: function (c, a, args, flag) {
                let url, i, fi = true;
                let preUrl = window._CONFIG.APP_URL + '/hdjlpt/yjzj';
                if (window._CONFIG.env !== 'production') {
                    preUrl = '';
                }
                if (window._CONFIG.isInIframe && !window._CONFIG.isSameDomain) {
                    preUrl = window._CONFIG.APP_URL;
                }
                url = preUrl + '/' + c + '/' + a;
                if (flag) {
                    url = url + '/' + args.join('/');
                } else {
                    if (args) {
                        for (i in args) {
                            if (fi) {
                                fi = false;
                                url += '?' + i + '=' + encodeURIComponent(args[i]);
                            } else {
                                url += '&' + i + '=' + encodeURIComponent(args[i]);
                            }
                        }
                    }
                }
                return url;
            }
        });
        window.injection = injection;
    }

});
